class Tabv2 {
   
    constructor(c = {}) {
        this.tabsTriggerParentv2 = c.tabsTriggerParentv2
        this.tabsContentParentv2 = c.tabsContentParentv2
        this.triggersv2 = this.tabsTriggerParentv2.querySelectorAll('.wu-tab')
        this.contentsv2 = this.tabsContentParentv2.querySelectorAll('.wu-tabs__content--pane')
        this.init()   
    }
    init() {
       
        this.listeners()
    }
    listeners() {
        var keyCode ={"RETURN":'13'};
        for (let i = 0; i < this.triggersv2.length; i++) {
            this.triggersv2[i].addEventListener('click', e => {
                let id = e.currentTarget.getAttribute("id")
                this.triggersClickHandlerv2(i, id)
                window.dispatchEvent(new CustomEvent('scroll'))
            })
            this.triggersv2[i].addEventListener("keyup", function (event) {
              event.preventDefault();
              if (event.keyCode === keyCode.RETURN) {
                let id = e.currentTarget.getAttribute("id")
                this.triggersClickHandlerv2(i, id)
                window.dispatchEvent(new CustomEvent('scroll'))
              }
            });
            
        }

    }

    triggersClickHandlerv2(index, id) {
        // triggers
        for (let i = 0; i < this.triggersv2.length; i++) {
            this.triggersv2[i].classList.remove('wu-tab--active','font-weight-500') 
        }
        this.triggersv2[index].classList.add('wu-tab--active', 'font-weight-500')

        //contents
        for (let i = 0; i < this.contentsv2.length; i++) {
            this.contentsv2[i].classList.remove('wu-tabs__content--pane--active')
        }
        this.tabsContentParentv2.querySelector(id).classList.add('wu-tabs__content--pane--active')
   
    }
}

let tabsTriggerParentv2 = document.querySelectorAll('.wu-tabs')
let tabsContentParentv2 = document.querySelectorAll('.wu-tabs__content')
if (
    tabsTriggerParentv2.length > 0 && tabsContentParentv2.length > 0 &&  tabsTriggerParentv2.length === tabsContentParentv2.length
) {
    for (let i = 0; i < tabsTriggerParentv2.length; i++) {
        new Tabv2({
            tabsTriggerParentv2: tabsTriggerParentv2[i],
            tabsContentParentv2: tabsContentParentv2[i]
        })
    }
}
document.addEventListener('catalogFifoEvent', (event) => {
    if(window.pageData?.template?.templateName === 'Corridor Template') {
        event.detail.then((result) => {
            const fifoTabs = document.querySelectorAll('.fifo-tab')
            if(fifoTabs && result?.services_groups){
                let funds_in = result?.available_funds_in?.split(',') || []
                let funds_out = [];
                result.services_groups.forEach(group => {
                    funds_out.push(group.fund_out_mnem);
                });
                if(funds_out || funds_in) {
                    const divider = document.createElement('div')
                    divider.classList.add('col-L-1')
                    fifoTabs?.forEach((tab)=>{ 
                        const fifoCards = tab.querySelectorAll('.fifo-card')
                        let cardCount = 0;
                        fifoCards?.forEach(function(card) {
                            const dataFifo = card.getAttribute('data-fifo');
                            if(card.nextElementSibling?.classList?.contains('col-L-1')) {
                                card.nextElementSibling.remove()
                            }
                            if(funds_in.includes(dataFifo) || funds_out.includes(dataFifo)) {
                                cardCount++;
                                toggleClass(card, "d-none", "d-flex");
                            } else {
                                toggleClass(card, "d-flex", "d-none");
                            }
                            //Add divider
                            (cardCount%3==0) ? card.after(divider) : ''
                        });
                        // Carousel dot count validator according to fifo cards
                        let dotRequired = (window.matchMedia('only screen and (max-width: 1024px)').matches) ? cardCount : ( cardCount>3 ? Math.ceil(cardCount/3) : 0);
                        const dots = tab.querySelectorAll('.wu-carousel-dots'); 
                        dots?.forEach((dot,i)=>{
                            if(i>=dotRequired){
                                toggleClass(dot,'d-inline-block','d-none')
                            } else {
                                toggleClass(dot,'d-none','d-inline-block');
                            }
                        });
                    });
                }
            }
        })
        .catch((error) => {
            console.error("Error:", error); 
        });
    }
}, { once: true }); // trigger event only once for page